<div class="login-page">
  <img class="login-logo" src="/snf-logo-full.png" alt="Social Network Finder" />

  <mat-card class="login-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>SNF Dashboard Login</mat-card-title>
      <mat-card-subtitle>Access admin dashboard with local or Google auth</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="card-content">
      <div class="panel local-panel">
        @if (!pendingTwoFa()) {
        <h3>Local Login</h3>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="email" />
            </mat-form-field>

            @if(loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched))
            {
            @if(loginForm.get('email')?.errors?.['required']) {
            <div class="error">Email is required.</div>
            }
            @if(loginForm.get('email')?.errors?.['email']) {
            <div class="error">Enter a valid email address.</div>
            }
            }
          </div>

          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input matInput type="password" formControlName="password" autocomplete="current-password" />
            </mat-form-field>

            @if(loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty ||
            loginForm.get('password')?.touched)) {
            @if(loginForm.get('password')?.errors?.['required']) {
            <div class="error">Password is required.</div>
            }
            }
          </div>

          <a mat-button class="text-action-btn" routerLink="/forget-password">
            Forgot password?
          </a>

          <button mat-flat-button type="submit" color="primary" class="submit-btn">
            Log In
          </button>

          <div class="auth-divider">
            <span></span>
            <strong>or</strong>
            <span></span>
          </div>

          @if (pendingTwoFa()) {
          <p class="status">Google login is disabled while 2FA verification is pending.</p>
          } @else {
          <div id="buttonDiv" class="google-button-wrap"></div>

          <!-- @if (isGoogleLoading()) {
          <p class="status">Loading Google sign-in...</p>
          }
          @if (googleReady()) {
          <p class="status success">Google sign-in ready.</p>
          } -->
          }
        </form>
        } @else {
        <h3>Two-Factor Verification</h3>
        <p class="panel-note">Enter the 6-digit code shown in your authenticator app to complete login.</p>
        <form [formGroup]="twoFaForm" (ngSubmit)="onVerify2FALogin()" class="login-form">
          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Authenticator Code</mat-label>
              <input matInput formControlName="token" inputmode="numeric" maxlength="6" autocomplete="one-time-code" />
            </mat-form-field>

            @if(twoFaForm.get('token')?.invalid && (twoFaForm.get('token')?.dirty || twoFaForm.get('token')?.touched)) {
            @if(twoFaForm.get('token')?.errors?.['required']) {
            <div class="error">Code is required.</div>
            }
            @if(twoFaForm.get('token')?.errors?.['pattern']) {
            <div class="error">Code must be 6 digits.</div>
            }
            }
          </div>

          <button mat-flat-button type="submit" color="primary" class="submit-btn">
            Verify 2FA
          </button>

          <button mat-stroked-button type="button" class="submit-btn" (click)="reset2FALogin()">
            Back to Login
          </button>
        </form>

        @if(backupEmailAvailable()) {
        <div class="login-form">
          <button mat-stroked-button type="button" class="submit-btn" [disabled]="recoveryCodeSent()"
            (click)="request2FARecovery()">
            Send recovery code to {{ maskedBackupEmail() || 'backup email' }}
          </button>

          @if(recoveryCodeSent()) {
          <form [formGroup]="recoveryForm" (ngSubmit)="onVerify2FARecovery()" class="login-form">
            <div class="field">
              <mat-form-field appearance="outline">
                <mat-label>Recovery Code</mat-label>
                <input matInput formControlName="otp" inputmode="numeric" maxlength="6"
                  autocomplete="one-time-code" />
              </mat-form-field>

              @if(recoveryForm.get('otp')?.invalid &&
              (recoveryForm.get('otp')?.dirty || recoveryForm.get('otp')?.touched)) {
              @if(recoveryForm.get('otp')?.errors?.['required']) {
              <div class="error">Recovery code is required.</div>
              }
              @if(recoveryForm.get('otp')?.errors?.['pattern']) {
              <div class="error">Recovery code must be 6 digits.</div>
              }
              }
            </div>

            <button mat-flat-button type="submit" color="primary" class="submit-btn">
              Verify Recovery Code
            </button>
          </form>
          }
        </div>
        }
        }
      </div>
    </mat-card-content>

    <!-- <mat-card-content class="token-box">
      <h3>Google ID Token (Credential)</h3>
      <textarea
        [value]="googleCredential()"
        rows="8"
        readonly
        placeholder="Sign in with Google to see your credential token here..."></textarea>
    </mat-card-content> -->

    @if (errorMessage()) {
    <mat-card-content>
      <div class="error-message">{{ errorMessage() }}</div>
    </mat-card-content>
    }
  </mat-card>
</div>
